import { css } from "@emotion/css"

export const box = css`
  width: 32rem;
  min-height: 24rem;
  padding: var(--spacing-xxl-2);
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const headerContainer = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--spacing-xxl-2);
`

export const row = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const column = css`
  display: flex;
  flex-direction: column;
`

export const subheader = css`
  margin-bottom: var(--spacing-xs);
`

export const item = css`
  display: flex;
  align-items: center;
  margin: -7px -12px;
  > span {
    &.MuiCheckbox-root {
      color: var(--light-grey);
    }
    &.MuiCheckbox-colorPrimary.Mui-checked {
      color: var(--primary-main);
    }
    &.MuiCheckbox-colorPrimary.Mui-disabled {
      color: var(--disabled-grey);
    }
  }
`

export const margin = css`
  margin-bottom: 1rem;
`

export const popover = css`
  max-height: calc(100% - 20.5rem);
  margin-top: var(--spacing-s);
`
